import Lottie from 'lottie-react';

import fireworks from '../jsons/fireworks-for-completed-notes.json';

const FireworksForCompletedNotes = props => {
  return <Lottie loop={false} animationData={fireworks} {...props} />;
};

export default FireworksForCompletedNotes;
